import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController, NavController, Platform } from '@ionic/angular';
import { DeviceService } from '../../../providers/device-service/device-service';
import { DeviceInfo } from '../../../data/device-info';
import { AppInfo } from '../../../data/app-info';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { LiveUpdateService } from 'services/live-update-service/live-update.service';
/**
 * Created by Ashok on 29-03-2016.
 */
@Component({
  templateUrl: 'about.page.html',
  selector: 'about-page',
  styleUrls: ['about.page.scss'],
})
export class AboutPage implements OnInit, OnDestroy {
  deviceInfo: DeviceInfo = {
    deviceId: 'unknown',
    virtual: true,
  };
  appInfo: AppInfo = {};
  currentVersion: string;

  constructor(
    private nav: NavController,
    private Location: Location,
    private router: Router,
    private deviceService: DeviceService,
    private modalCtrl: ModalController,
    private platform: Platform,
    private liveUpdate: LiveUpdateService
  ) {
    this.platform = platform;

    this.modalCtrl.dismiss();
  }

  async ngOnInit() {
    this.deviceService.getDeviceInfo().then((deviceInfo: DeviceInfo) => {
      this.deviceInfo = deviceInfo;
    });
    this.deviceService.getAppInfo().then((appInfo: AppInfo) => {
      this.appInfo = appInfo;
    });

    this.setCurrentVersion();
  }
  ngOnDestroy() {}
  versionCode() {
    // return this.platform.versions()
  }

  gotopage() {
    this.Location.back();
  }

  isCordova() {
    return this.platform.is('capacitor');
  }

  async setCurrentVersion() {
    this.currentVersion = await this.liveUpdate.getCurrentVersion();
  }

  onCheckUpdates() {
    this.liveUpdate.checkVersion(true);
  }
  // async sendMessage() {
  //     let deviceInfo: DeviceInfo = await this.deviceService.getDeviceInfo();
  //
  //     this.stompService.sendMessage(deviceInfo,
  //         '/app//mygolf2u-ws/device/register');
  // }
}
